class InfiniteScroll extends HTMLElement {
  constructor() {
    super();

    this.loading = false;
    this.parser = new DOMParser();
    this.button = this.querySelector('button');
    this.pagination = this.querySelector('#pagination');

    this.targetSelector = this.dataset.target || '#product-grid';
    this.itemSelector = this.dataset.item || '.collection__item';

    this.container = document.querySelector(this.targetSelector);

    this.setListeners();
  }

  setListeners() {
    this.button?.addEventListener('click', this.fetch.bind(this));
  }

  async fetch(e) {
    e.preventDefault();

    if (this.loading) return;

    const next = this.pagination.querySelector('a[data-next]');

    if (!next) return;

    this.loading = true;
    this.classList.add('loading');
    this.button && (this.button.disabled = true);

    try {
      const res = await fetch(next.href);

      if (!res.ok) throw new Error(res.status);

      const html = await res.text();

      this.render(html);
    } catch (err) {
      console.error('Infinite-scroll error:', err);
      this.finish();
    }
  }

  render(html) {
    const fragment = document.createDocumentFragment();
    const doc = this.parser.parseFromString(html, 'text/html');

    const items = doc.querySelectorAll(`${this.targetSelector} ${this.itemSelector}`);

    if (!items.length) {
      this.finish();
      return;
    }

    items.forEach(item => fragment.append(item));

    const newPagination = doc.querySelector('#pagination');

    if (newPagination) {
      this.pagination.innerHTML = newPagination.innerHTML;
    }

    this.container.append(fragment);

    const next = this.pagination.querySelector('a[data-next]');

    if (!next) {
      this.classList.add('hidden');
    }

    this.finish();
  }

  finish() {
    this.loading = false;
    this.classList.remove('loading');
    this.button && (this.button.disabled = false);
  }
}

customElements.define('infinite-scroll', InfiniteScroll);
